import { render, staticRenderFns } from "./addusuario.vue?vue&type=template&id=5bd11171"
import script from "./addusuario.vue?vue&type=script&lang=js"
export * from "./addusuario.vue?vue&type=script&lang=js"
import style0 from "./addusuario.vue?vue&type=style&index=0&id=5bd11171&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports